import { subActions } from "../../actionTypes";

const initialState = {
	paymentStatus: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case subActions.INIT_SUBSCRIPTION: {
			return { ...state, fetching: true };
		}

		case subActions.INIT_SUBSCRIPTION_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				paymentStatus: action.payload,
			};
		}

		case subActions.INIT_SUBSCRIPTION_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
			return state;
	}
};

export default Reducer;
